import { render, staticRenderFns } from "./jifenCard.vue?vue&type=template&id=0eb3c706&scoped=true&"
import script from "./jifenCard.vue?vue&type=script&lang=js&"
export * from "./jifenCard.vue?vue&type=script&lang=js&"
import style0 from "./jifenCard.vue?vue&type=style&index=0&id=0eb3c706&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb3c706",
  null
  
)

export default component.exports